export default __webpack_public_path__ + "images/3U.8ce17ce.png";